import { BaseModel } from './base-model';
import { Organization } from './organization';

export class MarketLevel extends BaseModel {
    MarketLevelName: string;
    Organization?: Organization;
    Parent?: MarketLevel;
    Rank: number;

    LevelRank?: number;
    name?: string;
    levelRank?: number;
}
